import { useClientAnalytics } from '@ilteducation/client-analytics';

type VideoSlicePlayed = {
  videoId: string;
  videoSessionId: string;
  categoryId?: string;
  areaId?: string;
  service: string;
  startSeconds: number;
  endSeconds: number;
  endReason: 'pause' | 'end' | 'seek' | 'settingChange' | 'heartbeat';
  narrationLanguage: string;
  subtitlesLanguage: string;
  playbackRate: string;
  subtitleSize: string;
  videoDurationSeconds?: number;
  // True when emitted during teardown/unload, so the request should survive the page being hidden.
  sentWhenPageHidden?: boolean;
};

export function sendVideoSlicePlayedAnalytics(slice: VideoSlicePlayed): void {
  const { sendAnalyticsEvent } = useClientAnalytics();

  sendAnalyticsEvent(
    'VideoPlayerEventType',
    {
      videoId: slice.videoId,
      videoSessionId: slice.videoSessionId,
      categoryId: slice.categoryId,
      areaId: slice.areaId,
      service: slice.service,
      videoDurationSeconds:
        slice.videoDurationSeconds === undefined ? undefined : Math.round(slice.videoDurationSeconds),
      eventName: 'video_slice_played',
      startSeconds: Math.round(slice.startSeconds),
      endSeconds: Math.round(slice.endSeconds),
      endReason: slice.endReason,
      narrationLanguage: slice.narrationLanguage,
      subtitlesLanguage: slice.subtitlesLanguage || 'off',
      playbackRate: slice.playbackRate,
      subtitleSize: slice.subtitleSize,
    },
    slice.sentWhenPageHidden ?? false,
  );
}
